<app-header-style-seven></app-header-style-seven>

<div class="rnd-page">
  <div class="custom-container">
    <section class="rnd-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Research & Innovation</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="content-head-card">
      <span class="content-tag">Institutional Cell</span>
      <h2>Research &amp; Development Cell</h2>
      <p>Fatima Michael College of Engineering &amp; Technology, Madurai.</p>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>About the R&amp;D Cell</h3>
        <p>
          The Research &amp; Development Cell promotes innovation, publications,
          funded projects, collaboration, and practical research exposure.
        </p>
      </div>

      <div class="section-copy">
        <p *ngFor="let paragraph of rdIntro">
          {{ paragraph }}
        </p>
      </div>

      <div class="numbered-list">
        <article class="number-card" *ngFor="let item of rdPoints; let i = index">
          <div class="number-badge">{{ i + 1 }}</div>
          <div>
            <p><strong>{{ item.title }}</strong></p>
            <p>{{ item.description }}</p>
          </div>
        </article>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>Research Advisory Council</h3>
        <p>Constitution of the Research Advisory Council of FMCET.</p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of researchAdvisoryCouncil">
              <td>{{ member.sno }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.designation }}</td>
              <td>{{ member.position }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="section-head mt-26">
        <h3>Research and Development Coordinator</h3>
      </div>

      <div class="coordinator-card">
        <h4>{{ rdCoordinator.name }}</h4>
        <p>{{ rdCoordinator.designation }}</p>
        <p>{{ rdCoordinator.department }}</p>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>Finance and Infrastructure Committee</h3>
        <p>Committee members supporting research finance and infrastructure planning.</p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of financeInfrastructureCommittee">
              <td>{{ member.sno }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.designation }}</td>
              <td>{{ member.position }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>Research Program &amp; Policy Development Committee</h3>
        <p>Committee members involved in research programmes and policy development.</p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of researchPolicyCommittee">
              <td>{{ member.sno }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.designation }}</td>
              <td>{{ member.position }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>Collaboration and Community Committee</h3>
        <p>Committee members supporting collaborations and external engagement.</p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of collaborationCommittee">
              <td>{{ member.sno }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.designation }}</td>
              <td>{{ member.position }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>Product Development, Monitoring and Commercialization Committee</h3>
        <p>Committee members supporting innovation, monitoring, and commercialization initiatives.</p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of productDevelopmentCommittee">
              <td>{{ member.sno }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.designation }}</td>
              <td>{{ member.position }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>IPR, Legal and Ethical Matters Committee</h3>
        <p>Committee members guiding intellectual property, legal, and ethical aspects of research.</p>
      </div>

      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Position</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of iprCommittee">
              <td>{{ member.sno }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.designation }}</td>
              <td>{{ member.position }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="content-card">
      <div class="section-head">
        <h3>R&amp;D Activities</h3>
        <p>
          Highlights of innovation and student participation activities conducted by the R&amp;D Cell.
        </p>
      </div>

      <div class="activity-grid">
        <article class="activity-card" *ngFor="let item of rdEventPhotos">
          <div class="activity-media">
            <img [src]="item.image" [alt]="item.caption" />
          </div>
          <div class="activity-body">
            <p>{{ item.caption }}</p>
          </div>
        </article>
      </div>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Research Culture</span>
        <h3>Innovation Through Academic Excellence</h3>
        <p>
          The R&amp;D Cell empowers faculty and students to explore ideas, build
          projects, publish research, and contribute meaningful solutions.
        </p>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Future Ready</span>
        <h3>Explore, Create, Collaborate</h3>
        <p>
          Through research, industry interaction, funded initiatives, and
          innovation activities, FMCET builds confident and creative problem solvers.
        </p>
      </article>
    </section>
  </div>
</div>